const pronouns = {
  male: "platform.fields.gender.option.male",
  female: "platform.fields.gender.option.female",
  they: "platform.fields.gender.option.other"
}

const genders = {
  male: "male",
  female: "female",
  they: "they"
}

export const genderOptions = [
  {name: genders.male, label: pronouns.male, value: "Male"},
  {name: genders.female, label: pronouns.female, value: "Female"},
  {name: genders.they, label: pronouns.they, value: "Unknown"}
]

export default [
  {gender: genders.male, pronoun: pronouns.male, initial: "M"},
  {gender: genders.female, pronoun: pronouns.female, initial: "F"},
  {gender: genders.they, pronoun: pronouns.they, initial: "N"}
]

export const defaultGender = {gender: genders.they, pronoun: pronouns.they, initial: "N"}
